module.exports = __webpack_public_path__ + "img/laitages.4c969298.svg";